/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

/**
 * @description general setting for modal
 */
function init() {
  if (typeof SmartOrderRefillSettings === 'undefined') return;

  if (typeof $.fn.dialog !== 'undefined') {
    SmartOrderRefillSettings.ModalType = 'dialog';
  } else if (typeof $.fn.modal !== 'undefined') {
    SmartOrderRefillSettings.ModalType = 'modal';
  }
  $('.sorlink.visually-hidden').removeClass('visually-hidden');
}

/**
 * @description get parameter value from url
 * @param {string} url url to pars
 * @param {string} name parameter to find
 * @returns {string} paramer value
 */
function getURLParameter(url, name) {
  return (RegExp(name + '=(.+?)(&|$)').exec(url) || [null, null])[1];
}

/**
 * @description fill Address Fields
 * @param {Object} address address object
 * @param {Object} $form form object
 */
function fillAddressFields(address, $form) {
  for (let x = 0; x < Object.keys(address).length; x += 1) {
    const field = Object.keys(address)[x];

    if (field !== 'ID' && field !== 'UUID' && field !== 'key' && field !== 'displayValue' && field !== 'type') {
      if (field === 'stateCode') {
        $form.find('[name$="stateCode"]').val(address.stateCode);
      }

      const fieldWrapper = $form.find('.form-row.sor-form-row.' + field.replace('Code', '')).find('.field-wrapper');
      if (!fieldWrapper.length) {
        continue;
      }

      if (fieldWrapper.find('input').length) {
        fieldWrapper.find('input').val(address[field]);
      } else if (fieldWrapper.find('select').length) {
        fieldWrapper.find('select').val(address[field]);
      }
    }
  }
}

module.exports = {
  getURLParameter: getURLParameter,
  fillAddressFields: fillAddressFields,
  init: init
};
